import { Route } from 'react-router-dom';
import { createRoute } from '@core/router';
import pestsDetailRoute from '@modules/alert-reports/pests/DetailPage';

const pestsRoutes = <Route path="pests/:name" {...createRoute(pestsDetailRoute)} />;

export default pestsRoutes;
